module.exports = __webpack_public_path__ + "static/media/General.167491ac.svg";